import { search } from 'lib/axios'
import { Filter } from 'state/ducks/space/models'

import { SearchResult } from './models'
import { mapFilterToParams, mapSearchResponseToSearchResult } from './utils'

/**
 * 地図検索の Search API（Redux thunk から呼ばれるクライアント専用）。
 */
export const fetchLocationUnits = async (params: Filter): Promise<SearchResult> => {
  const res = await search.get('/api/v2/search', { params: mapFilterToParams(params) })
  return mapSearchResponseToSearchResult(res.data)
}
